import _ from 'lodash';
export const giveArrayOnBasisOfCount = (count: number) => {
    let testCount: any = [];
    for (let i = 0; i < count; i++) {
        testCount.push(i);
    }
    return testCount;
}
export const setTestData = (props: any, totalCount: number, checkType: string) => {
    const { accordianTest, setTestAccordian, testDetails = {}, setIsComingFromTest, isComingFromTest = false, isTabOpened, setIsTabOpened, isBothTabOpen, setProgressBarForTest, progressBar } = props;
    if (checkType === 'both') {
        let contentId = '';
        let content_Id = '';
        let newAccordianTouchState: any = [];
        newAccordianTouchState = [...accordianTest];
        let completedQuestionCount = 0;
        const { contentRequestItemsId = {} } = testDetails;
        const testDataForArray = giveArrayOnBasisOfCount(totalCount);
        let checkContentCount = 0;
        if (!isBothTabOpen) {
            testDataForArray && testDataForArray.map((val: any, testIndex: number) => {

                if (contentRequestItemsId) {
                   
                    const { contents = [] } = contentRequestItemsId;
                    let indexOfTestUsed: any = [];
                    contents && contents.map((contentData: any, contentIndex: number) => {
                        const { content_id } = contentData;
                        if ((contentIndex + 1 )<= totalCount) {
                            if (content_id) {
                                const { content_id: { _id = '', contentId: contentIdQuestion = '', unresolvedFeedbackCount = 0 } = {}, sequenceNo = 0, status = {} } = contentData;

                                if (sequenceNo === (testIndex + 1) && !isComingFromTest && !isBothTabOpen) {
                                    contentId = contentIdQuestion;
                                    content_Id = _id;
                                    const { testContent = [] } = newAccordianTouchState[0];
                                    const isJobCompleted = _.get(status, 'creator.isJobCompleted', false);
                                    newAccordianTouchState[0] = {
                                        accordianIndex: 0,
                                        testContent: [
                                            ...testContent,
                                            {
                                                testIndex: testIndex + 1,
                                                attachedQuestions: {
                                                    content_Id,
                                                    contentId,
                                                    isJobCompleted,
                                                    isTouched: true,
                                                    unresolvedFeedbackCount,
                                                    previousVersion:{}
                                                }
                                            }
                                        ]
                                    }
                                    if (isJobCompleted) {
                                        completedQuestionCount = completedQuestionCount + 1;
                                    }
                                    contentId = '';
                                    content_Id = '';
                                    indexOfTestUsed.push(testIndex + 1);
                                }
                            }
                        }
                    });
                    // else {
                    if (!isComingFromTest && !indexOfTestUsed.includes(testIndex + 1) && !isBothTabOpen) {
                        const { testContent = [] } = newAccordianTouchState[0];
                        newAccordianTouchState[0] = {
                            accordianIndex: 0,
                            testContent: [
                                ...testContent,
                                {
                                    testIndex: testIndex + 1,
                                    attachedQuestions: {
                                        content_Id,
                                        contentId,
                                        isJobCompleted: false,
                                        isTouched: true,
                                        unresolvedFeedbackCount: 0,
                                        previousVersion:{}
                                    }
                                }
                            ]
                        }
                    }
                    // }
                }
                else {
                    const { testContent = [] } = newAccordianTouchState[0];
                    if (!isComingFromTest && !isBothTabOpen) {
                        newAccordianTouchState[0] = {
                            accordianIndex: 0,
                            testContent: [
                                ...testContent,
                                {
                                    testIndex: testIndex + 1,
                                    attachedQuestions: {
                                        content_Id,
                                        contentId,
                                        isJobCompleted: false,
                                        isTouched: false,
                                        unresolvedFeedbackCount: 0,
                                        previousVersion:{}
                                    }
                                }
                            ]
                        }
                    }
                }
            })

            // console.log('In setTestData', totalCount)
            // console.log('In setTestData', completedQuestionCount)
            setTestAccordian(newAccordianTouchState)
            setIsTabOpened({ booleanValue: true })
            setIsComingFromTest({ booleanValue: false })
            !isBothTabOpen && setProgressBarForTest({ totalCount, count: completedQuestionCount });
        }
    } else {
        let contentId = '';
        let content_Id = '';
        let newAccordianTouchState: any = [];
        newAccordianTouchState = [...accordianTest];
        let completedQuestionCount = 0;
        const { contentRequestItemsId = {} } = testDetails;
        const testDataForArray = giveArrayOnBasisOfCount(totalCount);
        let checkContentCount = 0;
        if (!isTabOpened) {
            testDataForArray && testDataForArray.map((val: any, testIndex: number) => {

                if (contentRequestItemsId) {
                    const { contents = [] } = contentRequestItemsId;
                    let indexOfTestUsed: any = [];
                    contents && contents.map((contentData: any) => {
                        const { content_id } = contentData;
                        if (content_id) {
                            const { content_id: { _id = '', contentId: contentIdQuestion = '', unresolvedFeedbackCount = 0 } = {}, sequenceNo = 0, status = {},  } = contentData;
                            if (sequenceNo === (testIndex + 1) && !isComingFromTest && !isTabOpened) {
                                contentId = contentIdQuestion;
                                content_Id = _id;
                                const isJobCompleted = _.get(status, 'creator.isJobCompleted', false);
                                const { testContent = [] } = newAccordianTouchState[0];
                                newAccordianTouchState[0] = {
                                    accordianIndex: 0,
                                    testContent: [
                                        ...testContent,
                                        {
                                            testIndex: testIndex + 1,
                                            attachedQuestions: {
                                                content_Id,
                                                contentId,
                                                isJobCompleted,
                                                isTouched: true,
                                                unresolvedFeedbackCount,
                                                previousVersion:{}
                                            }
                                        }
                                    ]
                                }
                                contentId = '';
                                content_Id = '';
                                if (isJobCompleted) {
                                    completedQuestionCount = completedQuestionCount + 1;
                                }
                                indexOfTestUsed.push(testIndex + 1);
                            }
                        }
                    });
                    // else {
                    if (!isComingFromTest && !indexOfTestUsed.includes(testIndex + 1) && !isTabOpened) {
                        const { testContent = [] } = newAccordianTouchState[0];
                        newAccordianTouchState[0] = {
                            accordianIndex: 0,
                            testContent: [
                                ...testContent,
                                {
                                    testIndex: testIndex + 1,
                                    attachedQuestions: {
                                        content_Id,
                                        contentId,
                                        isJobCompleted: false,
                                        isTouched: true,
                                        unresolvedFeedbackCount: 0,
                                        previousVersion:{}
                                    }
                                }
                            ]
                        }
                    }
                    // }
                }
                else {
                    const { testContent = [] } = newAccordianTouchState[0];
                    if (!isComingFromTest && !isTabOpened) {
                        newAccordianTouchState[0] = {
                            accordianIndex: 0,
                            testContent: [
                                ...testContent,
                                {
                                    testIndex: testIndex + 1,
                                    attachedQuestions: {
                                        content_Id,
                                        contentId,
                                        isJobCompleted: false,
                                        isTouched: false,
                                        unresolvedFeedbackCount: 0,
                                        previousVersion: {}
                                    }
                                }
                            ]
                        }
                    }
                }
            })
            // console.log('In setTestData', totalCount)
            // console.log('In setTestData', completedQuestionCount)
            setTestAccordian(newAccordianTouchState)
            setIsTabOpened({ booleanValue: true })
            setIsComingFromTest({ booleanValue: false })
            !isTabOpened && setProgressBarForTest({ totalCount, count: completedQuestionCount });
        }
    }
}